<div class="d-flex justify-content-center align-items-center p-provinces provinces-mobile">
    <!--<mat-form-field appearance="none" color="accent" class="select">
        <mat-label>{{'b2c.IDS_SELECT_PROVINCE' | translate}}</mat-label>
        <mat-select>
          <mat-option *ngFor="let province of provinces" [value]="province.abbreviation">
            {{province.name}}
          </mat-option>
        </mat-select>
    </mat-form-field>-->

    <select name="provinces" id="provinces" [(ngModel)]="selectedProvince" class="select" [ngClass]="selectedProvince != '' ? 'selected' : ''">
      <option value="" class="option">{{'b2c.IDS_SELECT_PROVINCE' | translate}}</option>
      <option *ngFor="let province of provinces" [value]="province.abbreviation" class="option">{{province.name}}</option>
    </select>

    <button mat-flat-button class="bticino-ico search-button" [disabled]="selectedProvince == ''" (click)= 'btnSearchInstaller()' value="selectedProvince">
      <span class="bticino-ico search"></span>
      <span class="font-search-button m-l-8">{{'b2c.IDS_SEARCH' | translate}}</span>
    </button>
</div>

<div class="selector-container grid grid-two">
    <app-selector
      *ngFor="let entry of dataEntries;"
      class="find-installer"
      [id]="entry.ID"
      [name]="entry.name | translate"
      [description]="entry.description | translate"
      [checked]="entry.checked"
      [tooltip]="entry.tooltip"
      [tooltipType]="tooltipType"
      [lateralPanelId]="entry.lateralPanelId"
      [isSingleItem]="false"
      [showDescription]="true"
      (selected)="onSelectorClicked($event)"
    >
    </app-selector>
</div>